module.exports = __webpack_public_path__ + "media/ztss-hero.b60d0dc1.jpg";